import React from "react";
import { Check, Zap } from "lucide-react";
import styles from "./SignupHero.module.css";

const HERO_BULLETS = [
  "Test automation for every skill level",
  "Plan, execute & track tests 10x faster",
  "Free your team from flaky tests & bottlenecks",
];

const SignupHero = () => (
  <div className={styles.hero} aria-hidden="true">
    <div className={styles.heroBg}>
      <div className={styles.heroGradient} />
      <div className={styles.heroShimmer} />
      <div className={styles.heroDots} />
    </div>

    <div className={styles.heroContent}>
      <h2 className={styles.heroHeadline}>Start streamlining QA in minutes.</h2>
      <p className={styles.heroSubtext}>
        Launch faster with modern, automated testing – all in one platform.
      </p>
      <ul className={styles.heroBullets}>
        {HERO_BULLETS.map((text) => (
          <li key={text}>
            <Check className={styles.checkIcon} size={18} strokeWidth={2.5} />
            <span>{text}</span>
          </li>
        ))}
      </ul>
      <div className={styles.heroBadgeRow}>
        <div className={styles.heroBadge}>10x ROI</div>
        <span className={styles.heroAiLabel}>
          <Zap size={16} strokeWidth={2} />
          Generate with AI
        </span>
      </div>
    </div>
  </div>
);

export default SignupHero;
